<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-tabs
        style="border-top-right-radius: 0.5rem; border-top-left-radius: 0.5rem"
        grow
        background-color="primary"
        active-class="subtitle-1 font-weight-bold"
        center-active
      >
        <v-tab>
          Exibição
          <span class="tab-count" :class="{ 'tab-count--hidden': !(num_coluna === 1 && !loading && dataModerada && dataModerada.totalItems > 0) }">
            {{ num_coluna === 1 && !loading && dataModerada && dataModerada.totalItems > 0 ? dataModerada.totalItems : '0' }}
          </span>
        </v-tab>
      </v-tabs>

      <v-container class="colab-toolbar-container" fluid v-if="cod_producao">
        <div class="colab-toolbar">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            solo flat dense hide-details
            placeholder=""
            background-color="surface_tertiary"
            v-model="filtro_texto_moderada"
            @input="onChange"
            @keypress.enter="handleClickEnter"
            aria-label="Buscar"
            class="colab-search"
          />

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <button class="colab-toolbar-btn colab-toolbar-btn--remove" aria-label="Remover todas as notícias em exibição" v-bind="attrs" v-on="on" @click="dialogRemoverNoticiasModeradas = true">
                <v-icon size="18">mdi-arrow-left</v-icon>
              </button>
            </template>
            <span>Remover todas as notícias em exibição</span>
          </v-tooltip>
        </div>

        <ModalConfirmAction
          :visible="dialogRemoverNoticiasModeradas"
          title="Remover notícias"
          message="Tem certeza que deseja remover todas as notícias moderadas?"
          confirmText="Remover"
          @confirm="removerTodasNoticiasModeradas"
          @cancel="dialogRemoverNoticiasModeradas = false"
        />

        <div
          @dragover.prevent="handleDragOver"
          @dragenter.prevent="handleDragOver"
          @dragleave="handleDragLeave"
          @drop="handleDrop($event)"
          class="drop-zone"
          :class="{ 'drop-zone--active': isDragOver }"
        >
          <template v-if="dataModerada">
            <template>
              <div
                v-for="item in dataModerada.items"
                :key="item.cod_noticia"
                class="card-item-wrapper"
                :class="{ 'drop-enter': lastDroppedId === item.cod_noticia }"
              >
                <CardNoticiaModerada
                  :item="item"
                  :dataModerada="dataModerada"
                  :get-noticias-aprovadas="getNoticiasAprovadas"
                  :get-noticias-moderadas="getNoticiasModeradas"
                  :num_coluna_telao="num_coluna_telao"
                  :pageModerada="pageModerada"
                  :page-aprovada="aprovadas_current_page"
                  :cod_pasta="cod_pasta"
                />
              </div>
            </template>
          </template>
        </div>
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import CardNoticiaModerada from "../Cards/Noticias/CardNoticiaModerada.vue";
import ModalConfirmAction from "../Modal/ModalConfirmAction.vue";
import { dropTargetMixin } from "@/mixins/dragAndDrop";

export default {
  mixins: [dropTargetMixin],
  components: { CardNoticiaModerada, ModalConfirmAction },
  data() {
    return {
      filtro_texto_moderada: "",
      isModalImagemAprovadasVisible: false,
      media_type: null,
      midia_url_aprovadas: null,
      num_coluna: 1,
      loading: false,
      dialogRemoverNoticiasModeradas: false,
    };
  },
  props: {
    dataModerada: { type: [Array, Object] },
    num_coluna_telao: Number,
    aprovadas_current_page: Number,
    pageModerada: Number,
    cod_producao: Number,
    cod_pasta: Number,
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
  },
  filters: {
    formatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    formatedHour(date) {
      return new Date(date).toLocaleTimeString().split(":").slice(0, 2).join(":");
    },
  },
  created() {
    this.filtro_texto_moderada =
      localStorage.getItem("@socialcam/filtro_texto_noticia_moderada") || "";
  },
  methods: {
    ...mapActions({
      getNoticiasAprovadas: "noticias/getNoticiasAprovadas",
      getNoticiasModeradas: "noticias/getNoticiasModeradas",
      setFiltroModeradas: "noticias/setFiltroModeradas",
    }),
    async showModalImagem(midia_url_aprovadas, media_type) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
      this.media_type = media_type;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    async handleClickEnter() {
      await this.getNoticiasModeradas({
        cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        page: this.pageModerada,
        size: 5,
        filtro_texto: this.filtro_texto_moderada,
      });
    },
    async onDropAction(item, selectedProducao) {
      const formData = {
        cod_noticia: item.cod_noticia,
        cod_producao: selectedProducao.cod_producao,
        cod_portal: item.cod_portal,
        dsc_titulo_resumido: item.dsc_titulo_resumido,
      };

      await apiClient.post("/noticiasModeradas/inserirNoticiaModerada", formData);
      await this.getNoticiasAprovadas({
        cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
        cod_producao: selectedProducao.cod_producao,
        flg_favorita: this.$store.state.noticias.flg_favorita,
        size: 5,
        page: this.aprovadas_current_page,
        filtro_texto: this.$store.state.noticias.filtro_aprovadas,
        cod_pasta: this.cod_pasta,
        cod_editoria: this.$store.state.portais.selectedEditoria,
      });
      await this.getNoticiasModeradas({
        cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
        cod_producao: selectedProducao.cod_producao,
        size: 5,
        page: this.pageModerada,
        filtro_texto: this.filtro_texto_moderada,
      });
    },

    onChange(e) {
      localStorage.setItem("@socialcam/filtro_texto_noticia_moderada", e);
      this.setFiltroModeradas(e);
      clearTimeout(this.debounce);

      this.debounce = setTimeout(() => {
        this.getNoticiasModeradas({
          cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          filtro_texto: this.filtro_texto_moderada,
          page: this.pageModerada,
          size: 5,
        });
      }, 1500);
    },

    async removerTodasNoticiasModeradas() {
      if (this.dataModerada.totalItems === 0) {
        this.$toast.info("Não existem notícias moderadas a serem removidas.");
        this.dialogRemoverNoticiasModeradas = false;
        return;
      }
      const cod_producao = this.$store.state.producoes.selectedProducao.cod_producao;
      const cod_portal = this.$store.state.portais.selectedPortal.cod_portal;
      await apiClient
        .post(
          `noticiasModeradas/removerTodasNoticiasModeradas/${cod_producao}/${cod_portal}`
        )
        .then(async () => {
          this.dialogRemoverNoticiasModeradas = false;
          this.$toast.success("Todas as notícias moderadas foram removidas.");
          await this.getNoticiasAprovadas({
            cod_portal: cod_portal,
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            flg_favorita: this.$store.state.noticias.flg_favorita,
            filtro_texto: this.$store.state.noticias.filtro_aprovadas,
            size: 5,
            page: this.aprovadas_current_page,
            cod_pasta: this.cod_pasta,
            cod_editoria: this.$store.state.portais.selectedEditoria,
          });
          await this.getNoticiasModeradas({
            cod_producao: cod_producao,
            cod_portal: cod_portal,
            size: 5,
            page: this.pageModerada,
            filtro_texto: this.filtro_texto_moderada,
          });
        })
        .catch((error) => {
          this.dialogRemoverNoticiasModeradas = false;
          console.error(error);
          this.$toast.error("Erro ao remover todas as notícias moderadas");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none !important;
  color: #171717 !important;
}

.card-item-wrapper {
  margin-bottom: 8px;
}
</style>
